export default __webpack_public_path__ + "assets/images/6b0cd5f9599c175774c15660438fbe50.jpg";